import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useParams, useNavigate} from 'react-router-dom';
import { ConsultarDatosGeneracionActaAyudaHumanitaria } from '../../../Auth/ConsultasApi';
import { useAuth } from '../../../Auth/AuthContext';
import { Row, Col, Button, Card } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import SignatureCanvas from "react-signature-canvas";
import apiService from './../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import DatosActaHtml from './DatosActaHtml';
import CameraCaptureModal, { cropWithQuad } from './CameraCaptureModal';
import MinutaHtml from './MinutaHtml';

export default function GenerarPdfAheConFirmaDigital(){
    const { token, rol, user } = useAuth();
    const navigate = useNavigate();
    const sigCanvas = useRef();
    const [showFirmaPersona, setShowFirmaPersona] = useState(false);
    const [firmaPersona, setFirmaPersona] = useState(null);
    const [firmaUsuario, setFirmaUsuario] = useState(null);
    const [swalProps, setSwalProps] = useState({});
    const [imageCedulaLadoA, setImageCedulaLadoA] = useState(null);
    const [imageCedulaLadoB, setImageCedulaLadoB] = useState(null);
    const [imageEvidenciaEntrega, setImageEvidenciaEntrega] = useState(null);
    const [imageEvidenciaEntregaComprobante, setImageEvidenciaEntregaComprobante] = useState(null);
    const [datosActa, setDatosActa] = useState([]);
    const { idCabezaFamilia } = useParams();
    const [datoIdPersonaCargado, setDatoIdPersonaCargado] = useState(null);
    const [showCamera, setShowCamera] = useState(false);
    const [showCameraB, setShowCameraB] = useState(false);
    const [showCameraEvidencia, setShowCameraEvidencia] = useState(false);
    const [showCameraComprobante, setShowCameraComprobante] = useState(false);
    const [procesoId, setProcesoId] = useState(null);
    const [atenciones, setAtenciones] = useState([]);
    const [procesoFirma, setProcesoFirma] = useState({
        id: null, proFecha: '', proTerminado: null, proIdpersona: ''
    });
    const [datosMinuta, setDatosMinuta] = useState([]);
    const [infoMinuta, setInfoMinuta] = useState([]);
    const [tieneAlimentos, setTieneAlimentos] = useState(false);
    const [showListaRecepcion, setShowListaRecepcion] = useState(false);
    const [listaCedulasRecepcion, setListaCedulasRecepcion] = useState([]);
    const handleCloseListaRecepcion = () => setShowListaRecepcion(false);
    const fetchVerificarProcesoFirma = async (idCabezaFamilia) => {
        const url = '/consultas/verificarexistenciaprocesofirma';
        const obj = {idCabezaFamilia: idCabezaFamilia}
        try {
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setProcesoFirma(result.procesoFirma);
            setAtenciones(result.AtencionesDto || []);
            return result;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const fetchDataAtenciones = async (idCabezaFamilia, rol) => {
        const url = '/consultas/ListarAtencionesAhe';
        const obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol }
        try {
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setAtenciones(result.atenciones);
        } catch (error) {
            console.error('Error fetching data:', error);
            Mensaje('Atenciones', `Hubo un error con la carga de datos con el documento ${idCabezaFamilia}`);
        }
    };
    async function cargarDatosProcesoFirma(procesoId, atencionesArg = []) {
        setProcesoId(procesoId);
        if (!(procesoId && atencionesArg.length > 0)) return;
        await ConsultarRegistroFirmas(atencionesArg);
        await Promise.all([
            ConsultarFirmaPersona(procesoId),
            consultarCedulaLadoA(procesoId),
            consultarCedulaLadoB(procesoId),
            consultarConstanciaUno(procesoId),
            consultarConstanciaDos(procesoId)
        ]);
    }
    async function ConsultarRegistroFirmas(atencionesArg = atenciones) {
        setDatosActa([]);
        setDatosMinuta([]);
        setInfoMinuta([]);
        setTieneAlimentos(false);
        (atencionesArg || [])
        .filter(item => item.incluirenacta)
        .forEach(async element => {
            await fetchData(element.idatencion, rol);
        });
    }
    const fetchData = async (id, rol) => {
        const obj = {idatencion: id, usrRolid: rol, usrId: user }
        try {
            setCargando(true);
            const response = await ConsultarDatosGeneracionActaAyudaHumanitaria({obj, token});
            
            const result = await response.data;
            setDatosActa(prev => [...prev, result]);
            setDatosMinuta(result.datosacta.filter(d => 
                d.ayuda?.includes("Alimento") || d.ayuda?.includes("Kits") || d.ayuda?.includes("Kit")
            ));
            setInfoMinuta(result.datosMinuta || []);
            setTieneAlimentos(
                result.datosacta.some(d => 
                    d.ayuda?.includes("Alimento") || d.ayuda?.includes("Kits") || d.ayuda?.includes("Kit")
                )
            )
            setDatoIdPersonaCargado(result.datosacta[0]?.idpersona || null);
        } catch (error) {
            
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    function handleCheckboxChange(event) {
        setAtenciones(prev =>
            prev.map(item =>
                item.idatencion === event
                    ? { ...item, incluirenacta: !item.incluirenacta }
                    : item
            )
        );
    }

    async function GuardarProcesoRegistroFirmas(idAtenciones, idCabezaFamilia) {
        const url = '/bodega/guardarprocesoregistrofirmas';
        const obj = { idAtenciones, idCabezaFamilia , usrId: user };
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            if (response.status === 200) {
                setProcesoFirma(result.procesoFirma);
                return result.procesoFirma;
            } else {
                Mensaje('Registro de firmas', 'Error al guardar el proceso de registro de firmas');
                return null;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            return null;
        } finally {
            setCargando(false);
        }
    }
    useEffect(() => {
        async function checkProcesoFirma() {
            setCargando(true);
            try {
                const result = await fetchVerificarProcesoFirma(idCabezaFamilia);
                const procesoId = result?.procesoFirma?.id;
                const atencionesProceso = result?.AtencionesDto || [];

                if (procesoId && atencionesProceso.length > 0) {
                    await cargarDatosProcesoFirma(procesoId, atencionesProceso);
                    return;
                }else if (procesoId && atencionesProceso.length === 0) {
                    Mensaje('Atenciones', 'Se encontró un proceso de firma asociado a este grupo familiar pero no tiene atenciones asociadas. Por favor, contacte al administrador del sistema.');
                    console.warn('Proceso de firma encontrado pero sin atenciones asociadas. ID del proceso:', procesoId);
                }

                if (!result) {
                    await fetchDataAtenciones(idCabezaFamilia, rol);
                }
            } finally {
                setCargando(false);
            }
        }
        checkProcesoFirma();
    }, [idCabezaFamilia, rol]);
    useEffect(() => {
        consultarFirmaUsuario(user);
    }, [rol, user]);
    async function IniciarRegistroFirmas() {
        const idAtenciones = atenciones.filter(item => item.incluirenacta).map(item => item.idatencion).join(',');
        if (!idAtenciones) {
            Mensaje('Atenciones', 'Debe seleccionar al menos una atención para iniciar el proceso de firmas.');
            return;
        }
        const procesoGuardado = await GuardarProcesoRegistroFirmas(idAtenciones, idCabezaFamilia);
        const procesoId = procesoGuardado?.id;
        await cargarDatosProcesoFirma(procesoId, atenciones);
    }
    
    const [Cargando, setCargando] = useState(false);
   
    // Inline styles in React format
    const containerStyle = { maxWidth: 900, margin: "auto", fontFamily: "Helvetica,Arial,sans-serif", fontSize: 14 };
    const firmaWidth = 600; 
    const firmaHeight = 200;
    const borderBoxStyle = { 
        border: "1px solid #ccc", 
        borderRadius: 4, 
        background: "#fafafa", 
        width: firmaWidth, 
        height: firmaHeight,
        overflow: "hidden" 
    };
    const imgPreviewStyle = { maxWidth: "100%", maxHeight: 300, border: "1px solid #ccc" };    

    function dataURLtoBlob(dataurl) {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }

    function getImageFileName(blob, baseName) {
        const mimeType = blob?.type || '';
        if (/svg|xml/i.test(mimeType)) {
            return `${baseName}.svg`;
        }
        return `${baseName}.png`;
    }

    async function blobToDataUrl(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    async function blobOrSvgToDataUrl(blob) {
        if (!(blob instanceof Blob)) {
            return null;
        }

        const mimeType = blob.type || '';
        if (/svg|xml/i.test(mimeType)) {
            const text = await blob.text();
            if (/<svg[\s>]/i.test(text)) {
                const svgBlob = new Blob([text], { type: 'image/svg+xml' });
                return await blobToDataUrl(svgBlob);
            }
        }

        return await blobToDataUrl(blob);
    }

    async function finalizarFirmaPersona() {
        if (firmaPersona === null) {
            Mensaje('Firma', 'No se ha capturado la firma de la persona.');
            return;
        }
        if (imageCedulaLadoA === null) {
            Mensaje('Cédula', 'No se ha capturado la cédula.');
            return;
        }
        if (imageEvidenciaEntrega === null) {
            Mensaje('Evidencia de Entrega', 'No se ha capturado la evidencia de entrega.');
            return;
        }
        const url = '/bodega/finalizarprocesoregistrofirmas';
        const obj = { procesoFirma: procesoFirma.id, idCabezaFamilia , usrId: user };
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                Mensaje('Registro de firmas', 'El proceso de registro de firmas se ha finalizado correctamente.');
                navigate(`/consulta/consultaatenciones/${idCabezaFamilia}`);
            } else {
                Mensaje('Registro de firmas', 'Error al finalizar el proceso de registro de firmas');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }

    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };

    const [firmaPenSize, setFirmaPenSize] = useState(2);
    const [cropTarget, setCropTarget] = useState(null);
    const [isSigning, setIsSigning] = useState(false);
    const [firmaContainerWidth, setFirmaContainerWidth] = useState(600);
    const firmaContainerRef = useRef(null);

    useEffect(() => {
        function updateWidth() {
            if (firmaContainerRef.current) {
                setFirmaContainerWidth(firmaContainerRef.current.offsetWidth);
            }
        }
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => window.removeEventListener('resize', updateWidth);
    }, []);

    async function GuardarCedulaLadoA(procesofirmasid, dataURL) {
        setCargando(true);
        const url = '/archivo/uploadfileaheactadigital';
        const formData = new FormData();
        const pngBlob = dataURLtoBlob(dataURL);
        formData.append('file', pngBlob, getImageFileName(pngBlob, 'CEDULALADOA'));
        formData.append('usrId', user);
        formData.append('procesofirmasid', procesofirmasid);
        formData.append('tipoImagen', 'cedulaA');
        try {
            const response = await apiService.uploaddoc(url, formData, token);
            if(response.status === 200){
                Mensaje('Subir archivo', JSON.stringify(response.data.message));
            }
        } catch (error) {
            if (error.status === 413) {
                Mensaje('Archivo demasiado grande', 'El archivo PDF supera el tamaño máximo permitido. Por favor, reduzca el tamaño del archivo e intente de nuevo.');
            } else if(error.status === 422){
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data.errors));
            } else if(error.status === 409){
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data));
            } else {
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data));
            }
        } finally {
            setCargando(false);
        }
    };
    async function GuardarCedulaLadoB(procesofirmasid, dataURL) {
        setCargando(true);
        const url = '/archivo/uploadfileaheactadigital';
        const formData = new FormData();
        const pngBlob = dataURLtoBlob(dataURL);
        formData.append('file', pngBlob, getImageFileName(pngBlob, 'CEDULALADOB'));
        formData.append('usrId', user);
        formData.append('procesofirmasid', procesofirmasid);
        formData.append('tipoImagen', 'cedulaB');
        try {
            const response = await apiService.uploaddoc(url, formData, token);
            if(response.status === 200){
                Mensaje('Subir archivo', JSON.stringify(response.data.message));
            }
        } catch (error) {
            if (error.status === 413) {
                Mensaje('Archivo demasiado grande', 'El archivo PDF supera el tamaño máximo permitido. Por favor, reduzca el tamaño del archivo e intente de nuevo.');
            } else if(error.status === 422){
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data.errors));
            } else if(error.status === 409){
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data));
            } else {
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data));
            }
        } finally {
            setCargando(false);
        }
    };
    async function GuardarEvidenciaEntrega(procesofirmasid, dataURL) {
        setCargando(true);
        const url = '/archivo/uploadfileaheactadigital';
        const formData = new FormData();
        const pngBlob = dataURLtoBlob(dataURL);
        formData.append('file', pngBlob, getImageFileName(pngBlob, 'EVIDENCIAENTREGA'));
        formData.append('usrId', user);
        formData.append('procesofirmasid', procesofirmasid);
        formData.append('tipoImagen', 'constanciaUno');
        try {
            const response = await apiService.uploaddoc(url, formData, token);
            if(response.status === 200){
                Mensaje('Subir archivo', JSON.stringify(response.data.message));
            }
        } catch (error) {
            if (error.status === 413) {
                Mensaje('Archivo demasiado grande', 'El archivo PDF supera el tamaño máximo permitido. Por favor, reduzca el tamaño del archivo e intente de nuevo.');
            } else if (error.status === 422) {
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data.errors));
            } else if (error.status === 409) {
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data));
            } else {
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data));
            }
        } finally {
            setCargando(false);
        }
    };
    async function GuardarComprobante(procesofirmasid, dataURL) {
        setCargando(true);
        const url = '/archivo/uploadfileaheactadigital';
        const formData = new FormData();
        const pngBlob = dataURLtoBlob(dataURL);
        formData.append('file', pngBlob, getImageFileName(pngBlob, 'COMPROBANTE'));
        formData.append('usrId', user);
        formData.append('procesofirmasid', procesofirmasid);
        formData.append('tipoImagen', 'constanciaDos');
        try {
            const response = await apiService.uploaddoc(url, formData, token);
            if(response.status === 200){
                Mensaje('Subir archivo', JSON.stringify(response.data.message));
            }
        } catch (error) {
            if (error.status === 413) {
                Mensaje('Archivo demasiado grande', 'El archivo PDF supera el tamaño máximo permitido. Por favor, reduzca el tamaño del archivo e intente de nuevo.');  
            } else if (error.status === 422) {
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data.errors));
            } else if (error.status === 409) {
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data));
            } else {
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data));
            }
        } finally {
            setCargando(false);
        }
    };
    const handleCropSave = async (cropped) => {
        if (cropTarget === 'A') {
            await GuardarCedulaLadoA(
                procesoFirma.id, 
                cropped)
            setImageCedulaLadoA(cropped);
        } else if (cropTarget === 'B') {
            await GuardarCedulaLadoB(
                procesoFirma.id, 
                cropped)
            setImageCedulaLadoB(cropped);
        } else if (cropTarget === 'EVIDENCIA') {
            await GuardarEvidenciaEntrega(
                procesoFirma.id,
                cropped
            );
            setImageEvidenciaEntrega(cropped);
        } else if (cropTarget === 'COMPROBANTE') {
            await GuardarComprobante(
                procesoFirma.id,
                cropped
            );
            setImageEvidenciaEntregaComprobante(cropped);
        }
    };
    useEffect(() => {
        if (isSigning) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isSigning]);
    async function consultarFirmaUsuario(id){
        setCargando(true);
        const url = '/archivo/consultarfirmausuario';
        const obj = { usrId: id };
        try {
            setCargando(true);
            const response = await apiService.getFile(url, obj, token);
            const dataUrl = await blobOrSvgToDataUrl(response.data);
            if (dataUrl) {
                setFirmaUsuario(dataUrl);
            } else {
                setFirmaUsuario(null);
            }
        } catch (error) {
            console.error('Error fetching firma usuario:', error);
            setFirmaUsuario(null);
        } finally {
            setCargando(false);
        }
    }
    async function ConsultarFirmaPersona(procesofirmasid) {
        setCargando(true);
        const url = '/archivo/consultarfileaheactadigital';
        const obj = { procesofirmasid: procesofirmasid, tipoImagen: 'Firma' };
        try {
            const response = await apiService.getFile(url, obj, token);
            const dataUrl = await blobOrSvgToDataUrl(response.data);
            if (dataUrl) {
                setFirmaPersona(dataUrl);
            } else {
                setFirmaPersona(null);
            }
        } catch (error) {
            console.error('Error fetching firma persona:', error);
            setFirmaPersona(null);
        } finally {
            setCargando(false);
        }
    }
    async function consultarCedulaLadoA(procesofirmasid) {
        setCargando(true);
        const url = '/archivo/consultarfileaheactadigital';
        const obj = { procesofirmasid: procesofirmasid, tipoImagen: 'cedulaA' };
        try {
            const response = await apiService.getFile(url, obj, token);
            const dataUrl = await blobOrSvgToDataUrl(response.data);
            if (dataUrl) {
                setImageCedulaLadoA(dataUrl);
            } else {
                setImageCedulaLadoA(null);
            }
        } catch (error) {
            console.error('Error fetching cedula lado A:', error);
            setImageCedulaLadoA(null);
        } finally {
            setCargando(false);
        }
    }
    async function consultarCedulaLadoB(procesofirmasid) {
        setCargando(true);
        const url = '/archivo/consultarfileaheactadigital';
        const obj = { procesofirmasid: procesofirmasid, tipoImagen: 'cedulaB' };
        try {
            setCargando(true);
            const response = await apiService.getFile(url, obj, token);
            const dataUrl = await blobOrSvgToDataUrl(response.data);
            if (dataUrl) {
                setImageCedulaLadoB(dataUrl);
            } else {
                setImageCedulaLadoB(null);
            }
        } catch (error) {
            console.error('Error fetching cedula lado B:', error);
            setImageCedulaLadoB(null);
        } finally {
            setCargando(false);
        }
    }
    async function consultarConstanciaUno(procesofirmasid) {
        setCargando(true);
        const url = '/archivo/consultarfileaheactadigital';
        const obj = { procesofirmasid: procesofirmasid, tipoImagen: 'constanciaUno' };
        try {
            const response = await apiService.getFile(url, obj, token);
            const dataUrl = await blobOrSvgToDataUrl(response.data);
            if (dataUrl) {
                setImageEvidenciaEntrega(dataUrl);
            } else {
                setImageEvidenciaEntrega(null);
            }
        } catch (error) {
            console.error('Error fetching constancia uno:', error);
            setImageEvidenciaEntrega(null);
        } finally {
            setCargando(false);
        }
    }
    async function consultarConstanciaDos(procesofirmasid) {
        setCargando(true);
        const url = '/archivo/consultarfileaheactadigital';
        const obj = { procesofirmasid: procesofirmasid, tipoImagen: 'constanciaDos' };
        try {
            const response = await apiService.getFile(url, obj, token);
            const dataUrl = await blobOrSvgToDataUrl(response.data);
            if (dataUrl) {
                setImageEvidenciaEntregaComprobante(dataUrl);
            } else {
                setImageEvidenciaEntregaComprobante(null);
            }
        } catch (error) {
            console.error('Error fetching constancia dos:', error);
            setImageEvidenciaEntregaComprobante(null);
        } finally {
            setCargando(false);
        }
    }
    async function guardarFirmaPersona(procesofirmasid, dataURL) {
        setCargando(true);
        const url = '/archivo/uploadfileaheactadigital';
        const formData = new FormData();
        const pngBlob = dataURLtoBlob(dataURL);
        formData.append('file', pngBlob, getImageFileName(pngBlob, 'PERSONAFIRM'));
        formData.append('usrId', user);
        formData.append('procesofirmasid', procesofirmasid);
        formData.append('tipoImagen', 'Firma');
        try {
            const response = await apiService.uploaddoc(url, formData, token);
            if(response.status === 200){
                Mensaje('Subir archivo', JSON.stringify(response.data.message));
                setShowFirmaPersona(false);
            }
        } catch (error) {
            if (error.status === 413) {
                Mensaje('Archivo demasiado grande', 'El archivo PDF supera el tamaño máximo permitido. Por favor, reduzca el tamaño del archivo e intente de nuevo.');
            } else if(error.status === 422){
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data.errors));
            } else if(error.status === 409){
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data));
            } else {
                Mensaje('Error subiendo archivo', JSON.stringify(error.response.data));
            }
            
        } finally {
            setCargando(false);
        }
    }
    async function BuscarArchivoCedula() {
        const url = `/ahe/ListarRecepcionesCedula/${idCabezaFamilia}`;
        try {
            const response = await apiService.get(url, token);
            if(response.status === 200){
                setListaCedulasRecepcion(response.data);
                setShowListaRecepcion(true);
            }
        } catch (error) {
            Mensaje('Error buscando archivo cedula', JSON.stringify(error.response.data));
        }
    }
    async function TraerArchivoCedula(archivoId) {
        setCargando(true);
        try {
            const response = await apiService.getFile('/ahe/obtenerceduladesderecepciondx', { filename: archivoId, procesoFirmaId: procesoId }, token);
            if (response.status === 200) {
                await consultarCedulaLadoA(procesoId)
                setShowListaRecepcion(false);
            }
        } catch (error) {
            Mensaje('Error trayendo archivo cedula', JSON.stringify(error.response?.data || error.message));
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Acta de entrega digital</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <NavLink to="/dashboard">Inicio</NavLink>
                                </li>
                                {idCabezaFamilia !== "0" && (
                                    <li className="breadcrumb-item">
                                        <NavLink to={`/consulta/consultaatenciones/${idCabezaFamilia}`}> Atenciones</NavLink>
                                    </li>
                                )}
                                <li className="breadcrumb-item active">Acta de entrega</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {Cargando && (
                        <div className="centered">
                            <div>
                                <progress value={null} />
                            </div>
                        </div>
                    )}
                </div>
                <Row>
                    <Col md={12} >
                        <Card>
                            <Card.Header>
                                <h3 className="card-title">Actas a incluir en la firma</h3>
                            </Card.Header>
                            <Card.Body>
                                {procesoFirma.id !== null && (
                                    <>
                                        <div>Proceso firma: {procesoFirma.id} iniciado el {new Date(procesoFirma.proFecha).toLocaleString()} con la cedula {procesoFirma.proIdpersona}</div>
                                        <Row className="my-4">
                                            <Col sm={12}>
                                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                                    <Button
                                                        variant="primary"
                                                        onClick={async () => {
                                                            await finalizarFirmaPersona();
                                                        }}
                                                    >
                                                        Finalizar firma
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                {procesoFirma.id === null && (
                                <div>
                                    {atenciones && atenciones.length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-striped table-sm">
                                                <thead>
                                                    <tr>
                                                        <th>Incluir en acta</th>
                                                        <th>ID Atención</th>
                                                        <th>Fecha</th>
                                                        <th>Id persona</th>
                                                        <th>Componente</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {atenciones.map((a) => (
                                                        <tr key={a.idatencion || a.id || JSON.stringify(a)}>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={a.incluirenacta || false}
                                                                    onChange={() => handleCheckboxChange(a.idatencion)}
                                                                />
                                                            </td>
                                                            <td>{a.idatencion}</td>
                                                            <td>{a.fecha ? a.fecha.split('T')[0] : ''}</td>
                                                            <td>{a.idpersona || ''}</td>
                                                            <td>{a.tipoayuda}-{a.observaciones}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div>No hay atenciones para mostrar.</div>
                                    )}
                                </div>
                                )}
                            </Card.Body>
                            {procesoFirma.id === null && (
                            <Card.Footer>
                                {atenciones.length > 0 && <Button variant="primary" onClick={IniciarRegistroFirmas}>
                                    Iniciar registro firmas
                                </Button>}
                            </Card.Footer>
                            )}
                        </Card>
                    </Col>
                </Row>
                {datosActa.length > 0 && <Row md={12}>
                    <Col sm={12}>
                        <Card>
                            <Card.Header>
                                <h3 className="card-title">Datos del acta</h3>
                            </Card.Header>
                            <Card.Body>
                                {datosActa
                                    .filter((element, idx, self) => 
                                        idx === self.findIndex(e => 
                                            e.datosacta?.[0]?.idatencion === element.datosacta?.[0]?.idatencion
                                        )
                                    )
                                    .map((element, idx) => (
                                        <DatosActaHtml key={idx} datosActa={element} />
                                    ))
                                }
                                <br />
                                {tieneAlimentos && (<MinutaHtml datosMinuta={datosMinuta} infoMinuta={infoMinuta} />)}
                                
                                <div style={containerStyle}>
                                    <div style={{ marginTop: 10 }}>
                                        <div style={{ marginBottom: 8 }}>
                                            <label htmlFor='firmaPenSize'>Tamaño de lápiz:&nbsp;</label>
                                            <input
                                                id='firmaPenSize'
                                                type="range"
                                                min={1}
                                                max={8}
                                                step={1}
                                                value={firmaPenSize}
                                                onChange={e => setFirmaPenSize(Number(e.target.value))}
                                                style={{ width: 120, verticalAlign: 'middle' }}
                                            />
                                            <span style={{ marginLeft: 8 }}>{firmaPenSize}px</span>
                                        </div>
                                        <div>
                                            <Row className="my-4">
                                                <Col>
                                                    <div><b>RECIBE</b></div>
                                                    {showFirmaPersona && (
                                                        <div
                                                            ref={firmaContainerRef}
                                                            style={{
                                                                ...borderBoxStyle,
                                                                width: '100%',
                                                                maxWidth: 600,
                                                                height: firmaHeight,
                                                                minWidth: 250,
                                                            }}
                                                        >
                                                            <SignatureCanvas
                                                                ref={sigCanvas}
                                                                penColor="black"
                                                                minWidth={firmaPenSize}
                                                                maxWidth={firmaPenSize}
                                                                canvasProps={{
                                                                    width: firmaContainerWidth,
                                                                    height: firmaHeight,
                                                                    className: "sigCanvas",
                                                                    style: { width: '100%', height: '100%' },
                                                                    onPointerDown: () => setIsSigning(true),
                                                                    onPointerUp: () => setIsSigning(false),
                                                                    onMouseDown: () => setIsSigning(true),
                                                                    onMouseUp: () => setIsSigning(false),
                                                                    onTouchStart: () => setIsSigning(true),
                                                                    onTouchEnd: () => setIsSigning(false)
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                    {!showFirmaPersona && (
                                                        <div style={{
                                                            ...borderBoxStyle,
                                                            width: '100%',
                                                            maxWidth: 600,
                                                            height: firmaHeight,
                                                            minWidth: 250,
                                                        }}>
                                                            {firmaPersona ? (
                                                                <img
                                                                    src={firmaPersona}
                                                                    alt="Firma Persona"
                                                                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                                                />
                                                            ) : (
                                                                <div style={{ textAlign: 'center', color: '#888', paddingTop: 60 }}>
                                                                    No hay firma registrada de la persona
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row className="my-4">
                                                 <Col sm={12}>   
                                                    {!showFirmaPersona && <Button
                                                        size="sm"
                                                        className="mt-2"
                                                        variant="info"
                                                        onClick={() => setShowFirmaPersona(true)}
                                                        >
                                                        Nueva firma
                                                    </Button>}
                                                    {showFirmaPersona && <Button
                                                        size="sm"
                                                        variant="secondary"
                                                        className="mt-2"
                                                        onClick={() => sigCanvas.current.clear()}
                                                    >
                                                        Limpiar firma
                                                    </Button>}
                                                    {showFirmaPersona && <Button 
                                                        size="sm"
                                                        variant="primary"
                                                        className="mt-2"
                                                        onClick={async () => {
                                                            if (sigCanvas.current && !sigCanvas.current.isEmpty()) {
                                                                const canvas = sigCanvas.current.getCanvas();
                                                                const dataUrl = canvas.toDataURL("image/png");
                                                                await guardarFirmaPersona(
                                                                    procesoFirma.id,
                                                                    dataUrl
                                                                );
                                                                setFirmaPersona(dataUrl);
                                                            }
                                                        }}
                                                    >
                                                        Guardar firma
                                                    </Button>}
                                                 </Col>
                                            </Row>
                                        </div>
                                        <div>
                                            <Row className="my-4">
                                                <Col sm={6}>
                                                    <div><b>ENTREGA</b>: {datosActa.usrNombre}</div>
                                                    <div
                                                        style={{
                                                            ...borderBoxStyle,
                                                            width: '100%',
                                                            maxWidth: 600,
                                                            minWidth: 250,
                                                            height: firmaHeight,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            background: '#fafafa',
                                                        }}
                                                    >
                                                        {firmaUsuario ? (
                                                            <img
                                                                src={firmaUsuario}
                                                                alt="Firma usuario"
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    maxWidth: '100%',
                                                                    maxHeight: '100%',
                                                                    objectFit: 'contain',
                                                                    display: 'block'
                                                                }}
                                                            />
                                                        ) : (
                                                            <div style={{ textAlign: 'center', color: '#888', width: '100%' }}>
                                                                No hay firma registrada para el Usuario
                                                            </div>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <Row className="my-4">
                                        <Col sm={6}>
                                            <h4>Lado frontal documento de identidad</h4>
                                            <Button
                                                size="sm"
                                                variant="success"
                                                onClick={() => {
                                                    setCropTarget('A');
                                                    setShowCamera(true);
                                                }}
                                            >
                                            Usar cámara
                                            </Button>
                                            <Button
                                                size="sm"
                                                variant="success"
                                                onClick={() => {
                                                    BuscarArchivoCedula();
                                                }}
                                            >
                                            Cedula recepcion
                                            </Button>
                                            <Modal show={showListaRecepcion} onHide={handleCloseListaRecepcion}>
                                                <Modal.Header closeButton>
                                                <Modal.Title>Listado recepcion</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div className="table-responsive">
                                                    <table className="table table-sm table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Acci&oacute;n</th>
                                                            <th>ID</th>
                                                            <th>Rep Identificación</th>
                                                            <th>Archivo</th>
                                                            <th>Medio</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {listaCedulasRecepcion.map(row => (
                                                        <tr key={row.id}>
                                                            <td>
                                                                {!Cargando && (
                                                                <Button
                                                                    size="sm"
                                                                    variant="primary"
                                                                    onClick={() => {
                                                                        TraerArchivoCedula(row.strCedulafile);
                                                                    }}
                                                                >
                                                                    Usar
                                                                </Button>
                                                                )}
                                                            </td>
                                                            <td>{row.id}</td>
                                                            <td>{row.repIdentificacion}</td>
                                                            <td>
                                                                <a href={`/${row.strCedulafile}`} target="_blank" rel="noreferrer">
                                                                {row.strCedulafile}
                                                                </a>
                                                            </td>
                                                            <td>{row.medio}</td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                    </table>
                                                    </div>
                                                </Modal.Body>
                                                <Modal.Footer>
                                                <Button variant="secondary" onClick={handleCloseListaRecepcion}>
                                                    Close
                                                </Button>
                                                <Button variant="primary" onClick={handleCloseListaRecepcion}>
                                                    Save Changes
                                                </Button>
                                                </Modal.Footer>
                                            </Modal>
                                            <CameraCaptureModal
                                                show={showCamera}
                                                onClose={() => setShowCamera(false)}
                                                onCapture={async (dataUrl, quad) => {
                                                    if (!window.cv) {
                                                        alert('OpenCV no está cargado');
                                                        await handleCropSave(dataUrl);
                                                        return;
                                                    }
                                                    const cropped = await cropWithQuad(dataUrl, quad, cropTarget);
                                                    await handleCropSave(cropped);
                                                }}
                                            />
                                            {imageCedulaLadoA && (
                                                <div style={{ marginTop: 16 }}>
                                                    <img
                                                        src={imageCedulaLadoA}
                                                        alt="Lado frontal Documento de identidad"
                                                        style={imgPreviewStyle}
                                                    />
                                                </div>
                                            )}
                                        </Col>
                                        <Col sm={6}>
                                            <h4>Lado trasero documento de identidad</h4>
                                            <Button 
                                                size="sm" 
                                                variant="success" 
                                                onClick={() => {
                                                    setCropTarget('B');
                                                    setShowCameraB(true)}
                                                    }>
                                                Usar cámara
                                            </Button>
                                            <CameraCaptureModal
                                                show={showCameraB}
                                                onClose={() => setShowCameraB(false)}
                                                onCapture={async (dataUrl, quad) => {
                                                    if (!window.cv) {
                                                        alert('OpenCV no está cargado');
                                                        await handleCropSave(dataUrl);
                                                        return;
                                                    }
                                                    const cropped = await cropWithQuad(dataUrl, quad, cropTarget);
                                                    await handleCropSave(cropped);
                                                }}
                                            />
                                            {imageCedulaLadoB && (
                                                <div style={{ marginTop: 16 }}>
                                                <img
                                                    src={imageCedulaLadoB}
                                                    alt="Lado trasero Documento de identidad"
                                                    style={imgPreviewStyle}
                                                />
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row className="my-4">
                                        <Col sm={6}>
                                            <h4>Evidencia entrega</h4>
                                            <Button 
                                                size="sm" 
                                                variant="success" 
                                                onClick={() => {
                                                    setCropTarget('EVIDENCIA');
                                                    setShowCameraEvidencia(true);
                                                }}>
                                                Usar cámara
                                            </Button>
                                            <CameraCaptureModal
                                                show={showCameraEvidencia}
                                                onClose={() => setShowCameraEvidencia(false)}
                                                onCapture={async dataUrl => {
                                                    // Si es EVIDENCIA, NO usar cropWithQuad, solo mostrar la imagen original
                                                    await handleCropSave(dataUrl);
                                                }}
                                            />
                                            {imageEvidenciaEntrega && (
                                                <div style={{ marginTop: 16 }}>
                                                <img
                                                    src={imageEvidenciaEntrega}
                                                    alt="Evidencia entrega"
                                                    style={imgPreviewStyle}
                                                />
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row className="my-4">
                                        <Col sm={6}>
                                            <h4>Comprobante de entrega</h4>
                                            <Button 
                                                size="sm" 
                                                variant="success" 
                                                onClick={() => {
                                                    setCropTarget('COMPROBANTE');
                                                    setShowCameraComprobante(true)}
                                                    }>
                                                Usar cámara
                                            </Button>
                                            <CameraCaptureModal
                                                show={showCameraComprobante}
                                                onClose={() => setShowCameraComprobante(false)}
                                                onCapture={async (dataUrl, quad) => {
                                                    if (!window.cv) {
                                                        alert('OpenCV no está cargado');
                                                        await handleCropSave(dataUrl);
                                                        return;
                                                    }
                                                    const cropped = await cropWithQuad(dataUrl, quad, cropTarget);
                                                    await handleCropSave(cropped);
                                                }}
                                                cropTarget={cropTarget}
                                            />
                                            {imageEvidenciaEntregaComprobante && (
                                                <div style={{ marginTop: 16 }}>
                                                <img
                                                    src={imageEvidenciaEntregaComprobante}
                                                    alt="Comprobante de entrega"
                                                    style={imgPreviewStyle}
                                                />
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>}
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
        </div>
    );
}